<template>
  <li class="onhover-dropdown">
    <div >
      <feather type="user-plus"></feather>
    </div>
    <ul class="profile-dropdown onhover-show-div p-20">
      <li><a @click="openModal('newAdmin')"><feather type="user-plus"></feather>Admin</a></li>
      <li><a @click="openModal('newKunde')"><feather type="user-plus"></feather>Kunde</a></li>
      <li><a @click="openModal('newDienstleister')"><feather type="user-plus"></feather>Dienstleister</a></li>
    </ul>

    <!-- Modal new Kunde -->
    <b-modal id="newKunde" @ok.prevent="validateKunde" @cancel="closeModal('newKunde')">
      <div class="card-body">
        <label>Vorname</label>&nbsp;
        <div class="red inline-block" v-if="hasError('first_name', 'kunde')">- mindestens {{ validation.kunden.first_name.minlength }} Zeichen.</div>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-form-input v-model="modal.kunde.first_name" v-bind:class="{ form_error: hasError('first_name', 'kunde') }"></b-form-input>
        </b-input-group>
        <label>Nachname</label>&nbsp;
        <div class="red inline-block" v-if="hasError('last_name', 'kunde')">- mindestens {{ validation.kunden.last_name.minlength }} Zeichen.</div>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-form-input v-model="modal.kunde.last_name" v-bind:class="{ form_error: hasError('last_name', 'kunde') }"></b-form-input>
        </b-input-group>
        <label>Email</label>&nbsp;
        <div class="red inline-block" v-if="hasError('email', 'kunde')">- gültige Email Addresse eingeben.</div>
        <b-input-group prepend="@" class="form-input-group">
          <b-form-input v-model="modal.kunde.email" v-bind:class="{ form_error: hasError('email', 'kunde') }"></b-form-input>
        </b-input-group>
        <div class="inline-block passwort-label">
        <input type="checkbox" v-model="modal.kunde.sendMail" class="inline-block" />
        <label>Passwort per E-Mail schicken</label>
        </div>
      </div>
      <template slot="modal-ok">Erstellen</template>
      <template slot="modal-cancel">Abbrechen</template>
      <template slot="modal-title">Neuer Kunde</template>
    </b-modal>
    <!-- Modal Kunde Ende -->

    <!-- Modal new Dienstleister -->
    <b-modal size="md" id="newDienstleister" name="name" @ok.prevent="validateDienstleister" @cancel="closeModal('newDienstleister')">
      <div class="card-body">
        <label>Name</label>
        <b-input-group prepend="Abc">
          <b-form-input
            class="form-control"
            v-model="modal.dienstleister.name"
            v-bind:class="{ form_error: hasError('name', 'dienstleister') }"
          ></b-form-input>
        </b-input-group>
      </div>
      <template slot="modal-ok">
        Erstellen
      </template>
      <template slot="modal-cancel">
        Abbrechen
      </template>
      <template slot="modal-title">
        Neuer Dienstleister
      </template>
    </b-modal>
    <!-- Modal Dienstleister Ende -->
    <!-- Modal Admin Beginn -->
    <b-modal id="newAdmin" @ok.prevent="validateAdmin" @cancel="resetModalState('admin')">
      <div class="card-body">
        <label>Vorname</label>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-form-input v-model="modal.admin.first_name" v-bind:class="{ form_error: hasError('first_name', 'admin') }"></b-form-input>
        </b-input-group>
        <label>Nachname</label>
        <b-input-group prepend="Abc" class="form-input-group">
          <b-form-input v-model="modal.admin.last_name" v-bind:class="{ form_error: hasError('last_name', 'admin') }"></b-form-input>
        </b-input-group>
        <label>Email</label>
        <b-input-group prepend="@" class="form-input-group">
          <b-form-input v-model="modal.admin.email" v-bind:class="{ form_error: hasError('email', 'admin') }"></b-form-input>
        </b-input-group>
        <label>Telefon</label>
        <b-input-group prepend="123" class="form-input-group">
          <b-form-input v-model="modal.admin.telefon" v-bind:class="{ form_error: hasError('telefon', 'admin') }"></b-form-input>
        </b-input-group>
        <label>als Ansprechpartner für</label>
        <div class="checkboxes-new-admin">
          <b-input-group class="form-input-group" v-for="thema in themen" :key="'thema_' + thema.id">
            <input
              type="checkbox"
              :name="thema.name"
              :data-thema-id="thema.id"
              @click="toggleThemaSelection"
              :checked="isSelectedThema(thema.name)"
            />
            <div style="bottom:3px;position:relative;margin-left:10px;">{{ thema.name }}</div>
          </b-input-group>
        </div>
      </div>
      <template slot="modal-header"><h5>Neuen Admin erstellen</h5></template>
      <template slot="modal-ok">Erstellen</template>
      <template slot="modal-cancel">Abbrechen</template>
    </b-modal>
  </li>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "createItems",
  data() {
    return {
      modal: {
        kunde: {
          first_name: "",
          last_name: "",
          email: "",
          sendMail: true,
        },
        dienstleister: {
          name: "",
        },
        admin: {
          first_name: "",
          last_name: "",
          email: "",
          themen: [],
          telefon: "",
        },
      },
      validation_errors: {
        kunde: [],
        admin: [],
        dienstleister: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      kunden: "app/kunden",
      animations: "app/animations",
      toasts: "app/toasts",
      ready: "app/readyState",
      validation: "app/validation",
      themen: "app/themen",
    }),
  },
  async created() {
    if(!this.themen) {
      try {
        await this.$store.dispatch("app/apiGetThemen");
      } catch(error) {
        console.log(error);
        console.log("Error getting Themen");
      }
    }
  },
  methods: {
    openModal(modal) {
      this.$bvModal.show(modal);
    },
    closeModal(modal) {
      this.$bvModal.hide(modal);
    },
    resetModalState(modal) {
      switch (modal) {
        case "kunde":
          this.modal.kunde = {
            first_name: "",
            last_name: "",
            email: "",
            sendMail: true,
          };
          break;
        case "dienstleister":
          this.modal.dienstleister = {
            name: "",
          };
          break;
        case "admin":
          this.modal.admin = {
            first_name: "",
            last_name: "",
            email: "",
            telefon: "",
            themen: [],
          };
      }
    },
    async validateAdmin() {
      this.validation_errors.admin = [];
      const fields = ["first_name", "last_name", "email", "telefon"];

      await Promise.all(
        fields.map(async (field) => {
          const result = await this.$store.dispatch("app/validateField", { context: "admin", field, value: this.modal.admin[field] });
          if (!result) this.validation_errors.admin.push(field);
        })
      );

      if (!this.validation_errors.admin.length) this.createAdmin();
    },
    async validateKunde() {
      this.validation_errors.kunde = [];
      const fields = ["first_name", "last_name", "email"];

      await Promise.all(
        fields.map(async (field) => {
          const result = await this.$store.dispatch("app/validateField", { context: "kunden", field, value: this.modal.kunde[field] });
          if (!result) this.validation_errors.kunde.push(field);
        })
      );
      if (!this.validation_errors.kunde.length) this.createKunde();
    },
    async validateDienstleister() {
      const fieldName = "name";
      const errorExists = this.validation_errors.dienstleister.indexOf(fieldName);
      if (errorExists > -1) this.validation_errors.dienstleister.splice(errorExists, 1);

      const validationPayload = {
        context: "dienstleister",
        field: fieldName,
        value: this.modal.dienstleister.name,
      };

      const validation_result = await this.$store.dispatch("app/validateField", validationPayload);
      if (!validation_result) {
        this.validation_errors.dienstleister.push(fieldName);
        return;
      }

      //create the new Dienstleister
      try {
        const response = await this.$directus.createItem("dienstleister", { name: this.modal.dienstleister.name, status: "published" });
        await this.$store.dispatch("app/apiGetDienstleister");
        this.closeModal("newDienstleister");
        this.$router.push("/admin/dashboard/dienstleister/" + response.data.id);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen des Dienstleisters.", this.toasts.failure);
      } finally {
        this.resetModalState("dienstleister");
      }
    },
    async createKunde() {
      //create the password
      const password = await this.$store.dispatch("app/generatePassword");

      //set payload for creation
      const createKundePayload = {
        ...this.modal.kunde,
        role: 3,
        status: "active",
        password,
      };
      console.log("in create kunde");
      //create the kunde

   
        const mailBody =
          `<p>Hallo ` +
          this.ucFirst(this.modal.kunde.first_name) +
          " " +
          this.ucFirst(this.modal.kunde.last_name) +
          `,</p>
      <p>
        Ihre Anmeldeinformationen für das infrabau Kommunikationstool lauten:
      </p>
      <p>
      <strong>Benutzer</strong> ` +
          this.modal.kunde.email +
          `<br />
      <strong>Passwort</strong> ` +
          password +
          `
      </p>

      <p>
      Nach der Anmeldung im Kommunikationstool können Sie Ihr Passwort über die Benutzerprofilseite ändern.
      </p>
      `;

        const mailPayload = {
          to: [this.modal.kunde.email],
          subject: "Ihr neues Konto für das infrabau Kommunikationstool",
          body: mailBody,
          type: "html",
        };
      

      try {
        const response = await this.$store.dispatch("app/createKunde", createKundePayload);
        await this.$store.dispatch("app/apiGetKunden");
        this.closeModal("newKunde");
        if(this.modal.kunde.sendMail) await this.$store.dispatch("mail/sendMail", mailPayload);
        this.$router.push("/admin/dashboard/kunde/" + response.data.id);
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
        console.log("inFinally block");
        this.resetModalState("kunde");
      }
    },
    hasError(field, context) {
      return this.validation_errors[context].indexOf(field) > -1 ? true : false;
    },
    isSelectedThema(thema) {
      return this.modal.admin.themen.indexOf(JSON.stringify(thema)) > -1 ? true : false;
    },
    toggleThemaSelection(clickEvent) {
      const themaObj = {
        name: clickEvent.target.name,
        id: clickEvent.target.dataset.themaId,
      };

      const isSelected = this.modal.admin.themen.indexOf(JSON.stringify(themaObj));
      if (isSelected > -1) this.modal.admin.themen.splice(isSelected, 1);
      if (isSelected == -1) this.modal.admin.themen.push(JSON.stringify(themaObj));
    },
    async createAdmin() {
      const password = await this.$store.dispatch("app/generatePassword");

      const createAdminPayload = {
        first_name: this.modal.admin.first_name,
        last_name: this.modal.admin.last_name,
        email: this.modal.admin.email,
        role: 1,
        password,
        status: "active",
      };

      //Passwort Mail
      const mailBody =
        `
      <p>Hallo ` +
        this.ucFirst(this.modal.admin.first_name) +
        " " +
        this.ucFirst(this.modal.admin.last_name) +
        `,</p>
      <p>
        Ihre Anmeldeinformationen für das infrabau Kommunikationstool lauten:
      </p>
      <p>
      <strong>Benutzer</strong> ` +
        this.modal.admin.email +
        `<br />
      <strong>Passwort</strong> ` +
        password +
        `
      </p>

      <p>
      Nach der Anmeldung im Kommunikationstool können Sie Ihr Passwort über die Benutzerprofilseite ändern.
      </p>
      `;

      const passwordMailPayload = {
        to: [this.modal.admin.email],
        subject: "Ihr Konto für infrabau",
        body: mailBody,
        type: "html",
      };

      try {
        const response = await this.$directus.createItem("directus_users", createAdminPayload);
        await this.createAnsprechpartner(response.data.id, this.modal.admin.telefon);
        await this.createThemenRelation(response.data.id, this.modal.admin.themen);
        this.closeModal("newAdmin");
        await this.$store.dispatch("mail/sendMail", passwordMailPayload);
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
      } finally {
        this.resetModalState("admin");
      }
    },
    async createThemenRelation(userId, themen) {
      for (let idx = 0; idx < themen.length; idx++) {
        try {
          const parsed = JSON.parse(themen[idx]);
          const createPayload = {
            user_id: userId,
            themen_id: parsed.id,
          };
          await this.$directus.createItem("ansprechpartner_themen_user", createPayload);
        } catch (error) {
          console.log(error);
          this.$toasted.show("Fehler beim Erstellen der Themen Relation", this.toasts.failure);
        }
      }
    },
    async createAnsprechpartner(userId, telefon) {
      const payload = {
        ansprechpartner: userId,
        telefon: telefon,
      };
      try {
        this.$directus.createItem("ansprechpartner", payload);
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Erstellen des Ansprechpartners.", this.toasts.failure);
      }
    },
  },
};
</script>
<style>
.checkboxes-new-admin {
  display:flex;
  justify-content:center;
}

.checkboxes-new-admin .input-group.form-input-group {
  justify-content:flex-start!important;
}
</style>